import * as api from '~services/api';
import { createAction } from '~reduxHelpers';
import { showServerErrorMsg } from '~actions/errorActions';

const initialState = {
  show: null,
  orderId: null,
  npsUrl: null,
  title: '',
  content: '',
};

export const setShow = createAction('SET_SHOW');
export const setOrderId = createAction('SET_ORDER_ID');
export const setNpsUrl = createAction('SET_NPS_URL');
export const setModalContents = createAction('SET_MODAL_CONTENTS');
export const receivePostedMessage = dataJson => {
  return { type: 'POSTED_MESSAGE', data: dataJson };
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'SET_SHOW': {
      return {
        ...state,
        show: action.payload,
        // If we're closing the modal, clear all the state
        orderId: !action.payload ? null : state.orderId,
        title: !action.payload ? null : state.title,
        content: !action.payload ? null : state.content,
        // Reset confirmation data when navigating off it
        confirmation:
          action.payload === 'CONFIRMATION'
            ? state.confirmation
            : initialState.confirmation,
      };
    }
    case 'SET_ORDER_ID': {
      return { ...state, orderId: action.payload };
    }
    case 'SET_NPS_URL': {
      return { ...state, npsUrl: action.payload };
    }
    case 'SET_MODAL_CONTENTS': {
      return {
        ...state,
        title: action.payload.title || '',
        content: action.payload.content || '',
      };
    }
    default:
      return state;
  }
};

export const submitFeedback = data => async dispatch => {
  try {
    const res = await api.post('messages/', data);
    dispatch(receivePostedMessage(res));
    dispatch(setShow(null));
  } catch (e) {
    console.error('Error in submitFeedback', e);
    dispatch(showServerErrorMsg(true));
  }
};

export default reducer;
